import { render, staticRenderFns } from "./LinkedIdpEditControls.vue?vue&type=template&id=e8dda8a4&scoped=true&"
import script from "./LinkedIdpEditControls.vue?vue&type=script&lang=ts&"
export * from "./LinkedIdpEditControls.vue?vue&type=script&lang=ts&"
import style0 from "./LinkedIdpEditControls.vue?vue&type=style&index=0&id=e8dda8a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8dda8a4",
  null
  
)

/* custom blocks */
import block0 from "./LinkedIdpEditControls.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports